import { msalClient } from "@/features/auth/authClient";
import { loginRequest } from "@/features/auth/authConfig";
import { env } from "@/config/env";

async function getAccessToken(): Promise<string> {
  const account = msalClient.getAllAccounts()[0];
  if (!account) throw new Error("No authenticated account found");

  const result = await msalClient.acquireTokenSilent({ ...loginRequest, account });
  return result.accessToken;
}
const API_BASE_URL = env.VITE_API_BASE_URL;
export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const token = await getAccessToken();
  const url = `${API_BASE_URL}${path}`;

  const response = await fetch(url, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...init?.headers
    }
  });

  if (!response.ok) {
    throw new Error(`API ${response.status}: ${response.statusText} — ${url}`);
  }

  const json = (await response.json()) as { data: T };
  return json.data;
}

/**
 * Like apiFetch but returns the raw Blob instead of unwrapping JSON.
 * Use this for endpoints that return binary content (e.g. Excel exports).
 */
export async function apiFetchBlob(path: string, init?: RequestInit): Promise<Blob> {
  const token = await getAccessToken();
  const url = `${API_BASE_URL}${path}`;

  const response = await fetch(url, {
    ...init,
    headers: {
      Authorization: `Bearer ${token}`,
      ...init?.headers
    }
  });

  if (!response.ok) {
    throw new Error(`API ${response.status}: ${response.statusText} — ${url}`);
  }

  return response.blob();
}
